import { action, computed, makeObservable, observable } from 'mobx';
import { VideoTrack } from '../models/VideoTrack';
import { VideoTrackApi } from '../api/VideoTrackApi';

class VideoTrackTimelineStore {
  private videoTrackMap: Map<VideoTrack['id'], VideoTrack>;

  private isVideoPlaying: boolean;

  private playingFrame: number;

  constructor() {
    this.videoTrackMap = new Map();
    this.isVideoPlaying = false;
    this.playingFrame = 0;

    makeObservable<VideoTrackTimelineStore, 'isVideoPlaying' | 'videoTrackMap' | 'playingFrame'>(this, {
      loadVideoTracks: action,
      setIsVideoPlaying: action,
      setPlayingFrame: action,
      all: computed,
      videoTrackMap: observable,
      isVideoPlaying: observable,
      playingFrame: observable,
    });
  }

  getVideoTrackMap() {
    return this.videoTrackMap;
  }

  getIsVideoPlaying() {
    return this.isVideoPlaying;
  }

  getPlayingTime() {
    return this.playingFrame;
  }

  setIsVideoPlaying(isVideoPlaying: boolean) {
    this.isVideoPlaying = isVideoPlaying;
  }

  setPlayingFrame(playingFrame: number) {
    this.playingFrame = playingFrame;
  }
  getPlayingFrame() {
    return this.playingFrame;
  }

  get all() {
    return Array.from(this.videoTrackMap.values());
  }

  public async loadVideoTracks(params: CF.API.PostAnnotationsSearchesCall) {
    const videoTracks = await VideoTrackApi.getVideoTracks(params);

    videoTracks.forEach((videoTrack) => {
      const trackId = videoTrack.getId();

      videoTrack.getKeyframes().forEach((keyframe) => {
        if (this.videoTrackMap.has(trackId)) {
          this.videoTrackMap.get(trackId)?.appendKeyframe(keyframe);
        } else {
          const track = new VideoTrack(trackId, [keyframe]);

          this.videoTrackMap.set(trackId, track);
        }
      });
    });
  }
}

export { VideoTrackTimelineStore };
